import _isArray from 'lodash/isArray';
import _isPlainObject from 'lodash/isPlainObject';

const STRING_ONLY_KEYS = ['search', 'ordering'];

const isPrimitive = val =>
  typeof val === 'string' ||
  typeof val === 'number' ||
  typeof val === 'boolean';

export const isValidRefinement = (key, val) => {
  if (STRING_ONLY_KEYS.includes(key)) return typeof val === 'string';
  if (isPrimitive(val)) return true;
  if (_isArray(val)) return val.every(isPrimitive);
  if (_isPlainObject(val)) {
    return (
      (val.type === 'range' || val.type === 'list') &&
      _isPlainObject(val.values)
    );
  }
  return false;
};

/**
 * Drops any refinement whose shape the table cannot process. Used on state
 * derived from untrusted sources (URL, localStorage).
 * @param {Object} [refinements]
 * @returns {Object|null}
 */
export const sanitizeRefinements = refinements => {
  if (!_isPlainObject(refinements)) return null;
  return Object.keys(refinements).reduce((acc, key) => {
    if (isValidRefinement(key, refinements[key])) {
      acc[key] = refinements[key];
    }
    return acc;
  }, {});
};
